/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { AppInfoTable } from "./AppInfoTable";
import { useAppInfo } from "../../store/useAppInfo";

function AppInfoScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getAppInfos, appInfos } = useAppInfo();

  /** Callbacks */
  const addAppInfo = () => navigate("/add-appinfo");

  useEffect(() => {
    getAppInfos();
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-6">
          Recycling info
        </h1>
        <PrimaryButton
          onClick={addAppInfo}
          label="Add new recycling info"
          className="h-8 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark "
          size="sm"
        />
      </div>
      <div className="w-full px-7 py-7 bg-white drop-shadow-none rounded-xl">
        {!appInfos?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no App Info created yet.
          </p>
        ) : (
          <AppInfoTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(AppInfoScreen);
